module.exports = __webpack_public_path__ + "static/media/HamburgerMenuScreen.bcae5317.png";